import { API } from "@/services/api";
import { IAPIResponse } from "@/services/api.types";
import { asksEndpoints, ratingsEndpoints } from "@/constant/endpoints";
import {
  Ask,
  AskFormData,
  AskReply,
  AskReplyFormData,
  DealUpdateFormData,
  Rating,
  RatingFormData,
  RatingPublishPayload,
} from "@/types/ratingsAsks.types";

// ============ Ratings ============
export const getRatingsService = async (dealId: string): Promise<Rating[]> => {
  const response = await API.Get<Rating[]>(ratingsEndpoints.dealRatings(dealId));
  if (response.data) return response.data;
  throw new Error(response.message);
};

export const postRatingService = async (
  dealId: string,
  payload: RatingFormData
): Promise<IAPIResponse<Rating>> => {
  return API.Post<RatingFormData, Rating>(ratingsEndpoints.dealRatings(dealId), payload);
};

export const patchRatingPublishService = async (
  ratingId: string,
  payload: RatingPublishPayload
): Promise<IAPIResponse<{ ok: boolean }>> => {
  return API.Patch<RatingPublishPayload, { ok: boolean }>(ratingsEndpoints.publishRating(ratingId), payload);
};

// ============ Asks ============
export const getAsksService = async (dealId: string): Promise<Ask[]> => {
  const response = await API.Get<Ask[]>(asksEndpoints.dealAsks(dealId));
  if (response.data) return response.data;
  throw new Error(response.message);
};

export const postAskService = async (dealId: string, payload: AskFormData): Promise<IAPIResponse<Ask>> => {
  return API.Post<AskFormData, Ask>(asksEndpoints.dealAsks(dealId), payload);
};

export const postDealUpdateService = async (
  dealId: string,
  payload: DealUpdateFormData
): Promise<IAPIResponse<Ask>> => {
  return API.Post<DealUpdateFormData, Ask>(asksEndpoints.dealUpdates(dealId), payload);
};

export const postAskReplyService = async (
  askId: string,
  payload: AskReplyFormData
): Promise<IAPIResponse<AskReply>> => {
  return API.Post<AskReplyFormData, AskReply>(asksEndpoints.replyAsk(askId), payload);
};

export const patchCloseAskService = async (askId: string): Promise<IAPIResponse<{ ok: boolean }>> => {
  return API.Patch<undefined, { ok: boolean }>(asksEndpoints.closeAsk(askId));
};
